import { ServiceSessionStorageBase } from "@/services/storage/base/service-session-storage-base";
import { SettingsHandler } from "@/services/storage/base/storage-abstractions";

export abstract class SettingsStorageMixin<T>
  extends ServiceSessionStorageBase
  implements SettingsHandler<T>
{
  private readonly settingsKey = "settings";

  protected abstract setSettingsInternal(
    settings: any,
    value: any,
    field: T,
  ): void;

  async getSettings(): Promise<any> {
    return JSON.parse((await this.getDataDB(this.settingsKey)) ?? "{}");
  }

  async setSettings(value: any, field: T): Promise<void> {
    const settings = await this.getSettings();
    this.setSettingsInternal(settings, value, field);

    await this.saveDataDB(this.settingsKey, JSON.stringify(settings));
  }
}
